import styled from "styled-components";

export const Container = styled.div`
    position: fixed;
    width: 100%;
    height: ${(props) => (props.$height ? '72px' : '50px')};
    background: radial-gradient(100% 95% at 95% 50%, #3E78AA 0%, #55965E 80%);
    z-index: 99999;
    border-radius: 0px 0px 37.95px 37.95px;
    @media (min-width: 720px) {
        display: none;
    }
`;

export const Content = styled.div`
    display: flex;
    align-items: center; 
    justify-content: space-around;
    background: #006560;
    width: 100%;
    height: 90%;
    border-radius: 0px 0px 37.95px 37.95px;
    padding-inline: 30px;
`;

export const NameText = styled.h1`
    color: var(--white-100, #FFF);
    leading-trim: both;
    text-edge: cap;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const NameContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center; 
    justify-content: center;
    gap: 10px;
`;

export const ProfileImage = styled.img`
    display: flex;
    width: 40px;
    height: 40px;
    border-radius: 50px;
`;

export const LogOutContainer = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center; 
    justify-content: center;
    padding: 10px;
    gap: 10px;
    border: none;
    width: auto;
    background: transparent;
    color: inherit;
    font: inherit;
    line-height: normal;
    cursor: pointer;
    outline: none;
`;

export const LogOutImage = styled.img`
    display: flex;
    width: 30px;
    height: 30px;
`;

export const LogOutText = styled.h3`
    color: #F2F2F2;
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;